import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  MenuItem,
  Select,
  AppBar,
  Toolbar,
  Paper,
  TextField,
  Typography,
  Tooltip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Addmodule = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [courseId, setcourseId] = useState('');
  const [module, setmodule] = useState('');
  const navigate = useNavigate();

  // Static course data
  const courseData = [
    { courseId: 1, courseName: 'C++' },
    { courseId: 2, courseName: 'Web Development' },
    { courseId: 3, courseName: 'Java' },
    { courseId: 4, courseName: 'Python' },
  ];

  const handleSave = (e) => {
    e.preventDefault();
    // Simulate API call with timeout
    setTimeout(() => {
      console.log('module saved:', { moduleName: module, courseId });
      setcourseId('');
      setmodule('');
      setShowSuccessModal(true);
    }, 500);
  };

  const handleCancel = () => {
    setcourseId("");
    setmodule("");
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <Box
          sx={{
            backgroundColor: 'rgba(2, 78, 101, 1)', // dark navy blue
            padding: '12px 16px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
           width: "100%",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
        Add module
      </Typography> </Box>

       <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="course">Course</InputLabel>
            <Select
              id="course"
              value={courseId}
              label="course"
              onChange={(e) => setcourseId(e.target.value)}
            >
              {courseData.map((courseItem) => (
                <MenuItem key={courseItem.courseId} value={courseItem.courseId}>
                  {courseItem.courseName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            id="module"
            label="Module"
            variant="outlined"
            value={module}
            onChange={(e) => setmodule(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!courseId ? "Select course" : !module ? "Enter module Name" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!module || !courseId}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              module Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              module Added Successfully
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default Addmodule;